import type { IconNameExtended } from "@/components/library/Icon";

export const CATEGORY_ICONS: Record<string, IconNameExtended> = {
  "company-news": "bullhorn",
  product: "rocket",
  "industry-insights": "chart-line",
  engineering: "code",
  "customer-stories": "comments",
};
